import { Button, Form, Input, Upload } from "antd";
import { InboxOutlined, CameraOutlined } from "@ant-design/icons";
import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { updateUserProfile } from "../../../redux/action/user";
import CustomModal from "../../CustomModal";
import { useTranslation } from "react-i18next";

const UpdateProfile = ({ updateProfile, setUpdateProfile }) => {
  const { user, profile_image } = useSelector((state) => state.userSlice);
  const formRef = useRef();
  const [fileList, setFileList] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (profile_image) {
      setImageUrl(profile_image);
    }
  }, [profile_image]);

  const handleFormSubmit = async (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    if (fileList.length > 0) {
      formData.append("file", fileList[0].originFileObj);
    }
    await updateUserProfile(formData);
    setUpdateProfile(false);
  };

  const handleOk = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
    if (fileList.length > 0) {
      const reader = new FileReader();
      reader.onload = () => setImageUrl(reader.result);
      reader.readAsDataURL(fileList[0].originFileObj);
    }
  };

  // Upload button click handler
  const handleUploadButtonClick = () => {
    // Upload component ke hidden input ko trigger karte hain
    const fileInput = document.querySelector(
      '.profile-image-uploader input[type="file"]'
    );
    if (fileInput) {
      fileInput.click();
    } else {
      // Fallback: agar specific selector nahi mila to generic try karte hain
      const allFileInputs = document.querySelectorAll('input[type="file"]');
      if (allFileInputs.length > 0) {
        allFileInputs[allFileInputs.length - 1].click(); // Last file input click karte hain
      }
    }
  };

  const { t } = useTranslation();

  return (
    <CustomModal
      visible={updateProfile}
      title={`${t("common.update")} ${t("common.profile")}`}
      okBtnText="Update"
      width={400}
      handleOk={handleOk}
      handleCancel={() => setUpdateProfile(false)}
      footer={false}
      className="my-custom-modal"
    >
      <Form
        ref={formRef}
        layout="vertical"
        initialValues={{ name: user?.name }}
        onFinish={handleFormSubmit}
      >
        <Form.Item>
          <div className="profile-upload-container">
            <Upload
              beforeUpload={() => false}
              fileList={fileList}
              onChange={handleFileChange}
              maxCount={1}
              showUploadList={false}
              className="profile-image-uploader"
            >
              <div
                className="upload-circle"
                onMouseEnter={(e) => {
                  const overlay =
                    e.currentTarget.querySelector(".upload-overlay");
                  if (overlay && imageUrl) overlay.classList.add("show");
                }}
                onMouseLeave={(e) => {
                  const overlay =
                    e.currentTarget.querySelector(".upload-overlay");
                  if (overlay) overlay.classList.remove("show");
                }}
              >
                {imageUrl ? (
                  <>
                    <img
                      src={imageUrl}
                      alt="Profile"
                      className="profile-image"
                    />
                    <div className="upload-overlay">
                      <CameraOutlined className="camera-icon" />
                    </div>
                  </>
                ) : (
                  <div className="upload-placeholder">
                    <InboxOutlined className="upload-icon2" />
                    <span>Upload Photo</span>
                  </div>
                )}
              </div>
            </Upload>
            <p className="upload-hint">
              <Button type="link" onClick={handleUploadButtonClick}>
                {t("common.upload")} {t("common.image")}
              </Button>{" "}
            </p>
          </div>
        </Form.Item>
        <Form.Item
          label={<span className="font-color">{t("common.name")}</span>}
          name="name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input className="custom-input" />
        </Form.Item>

        <div className="figma-modal-footer">
          <Button
            onClick={() => setUpdateProfile(false)}
            className="figma-cancel-btn"
          >
            {t("common.cancel")}
          </Button>

          <Button
            type="primary"
            onClick={handleOk}
            className="figma-delete-btn"
          >
            {t("common.update")}
          </Button>
        </div>
      </Form>
    </CustomModal>
  );
};

export default UpdateProfile;
